// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Bootstrap Extensions for MastiShorts */

/* IMPORTANT: Global Reset - Remove ALL underlines from the entire project */
* {
  text-decoration: none !important;
}

*:before, *:after {
  text-decoration: none !important;
}

/* Global Reset - Remove underlines from all lists and links */
ul, ol, li {
  text-decoration: none !important;
  list-style: none;
}

ul li, ol li {
  text-decoration: none !important;
}

a, a:hover, a:focus, a:active {
  text-decoration: none !important;
}

.nav-link, .nav-link:hover, .nav-link:focus, .nav-link:active {
  text-decoration: none !important;
}

/* Bootstrap nav override */
.navbar-nav .nav-link {
  text-decoration: none !important;
}

.navbar-nav .nav-link:hover {
  text-decoration: none !important;
}

/* Comprehensive element overrides */
div, span, p, h1, h2, h3, h4, h5, h6, 
ul, ol, li, dl, dt, dd,
nav, header, footer, main, section, article, aside,
button, input, select, textarea, label,
.card, .card-body, .card-title, .card-text,
.btn, .nav, .navbar, .dropdown, .modal,
.form-control, .form-label, .form-text,
.list-group-item, .dropdown-item, .breadcrumb-item,
.page-link, .nav-tabs .nav-link, .nav-pills .nav-link {
  text-decoration: none !important;
}

/* Hover states */
div:hover, span:hover, p:hover, h1:hover, h2:hover, h3:hover, h4:hover, h5:hover, h6:hover,
ul:hover, ol:hover, li:hover, dl:hover, dt:hover, dd:hover,
nav:hover, header:hover, footer:hover, main:hover, section:hover, article:hover, aside:hover,
button:hover, input:hover, select:hover, textarea:hover, label:hover,
.card:hover, .card-body:hover, .card-title:hover, .card-text:hover,
.btn:hover, .nav:hover, .navbar:hover, .dropdown:hover, .modal:hover,
.form-control:hover, .form-label:hover, .form-text:hover,
.list-group-item:hover, .dropdown-item:hover, .breadcrumb-item:hover,
.page-link:hover, .nav-tabs .nav-link:hover, .nav-pills .nav-link:hover {
  text-decoration: none !important;
}

/* Remove any extra margins and padding */
section {
  margin: 0 !important;
}

/* Navbar Styles */
.nav-bar {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.nav-bar .navbar-brand h1 {
  transition: all 0.3s ease;
}

.nav-bar .navbar-brand:hover h1 {
  transform: scale(1.05);
}

.nav-bar .navbar-nav .nav-link {
  position: relative;
  transition: all 0.3s ease;
  padding: 0.8rem 1rem !important;
  margin: 0 0.2rem;
  border-radius: 25px;
}

.nav-bar .navbar-nav .nav-link:hover {
  background-color: rgba(13, 110, 253, 0.1);
  color: var(--bs-primary) !important;
}

.nav-bar .navbar-nav .nav-link.active {
  background-color: var(--bs-primary);
  color: white !important;
}

/* Mobile Navbar Fixes */
@media (max-width: 991.98px) {
  .navbar-collapse {
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 10px;
    margin-top: 10px;
    padding: 15px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
  }
  
  .navbar-collapse.collapse:not(.show) {
    display: none !important;
  }
  
  .navbar-collapse.show {
    display: block !important;
  }
  
  .navbar-nav {
    flex-direction: column;
  }
  
  .nav-link {
    text-align: center;
    margin: 5px 0;
  }
}

@media (min-width: 992px) {
  .navbar-collapse {
    display: flex !important;
    position: static;
    background: none !important;
    box-shadow: none !important;
    border: none !important;
    margin-top: 0 !important;
    padding: 0 !important;
  }
  
  .navbar-nav {
    flex-direction: row;
  }
}

/* Header Carousel Fixes */
.header-carousel {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
}

.header-carousel-item {
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.header-carousel-item.active {
  opacity: 1;
}

/* Hover Effects */
.hover-lift {
  transition: all 0.3s ease;
}

.hover-lift:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
}

.hover-primary {
  transition: all 0.3s ease;
}

.hover-primary:hover {
  color: var(--bs-primary) !important;
  transform: translateX(5px);
}

/* Gradient Backgrounds */
.bg-gradient-primary {
  background: linear-gradient(135deg, var(--bs-primary), #6f42c1);
}

.bg-gradient-success {
  background: linear-gradient(135deg, var(--bs-success), #20c997);
}

.bg-gradient-info {
  background: linear-gradient(135deg, var(--bs-info), #0dcaf0);
}

.bg-gradient-warning {
  background: linear-gradient(135deg, var(--bs-warning), #fd7e14);
}

.bg-gradient-dark {
  background: linear-gradient(135deg, rgba(0,0,0,0.8), rgba(0,0,0,0.4));
}

/* Backdrop Blur Effect */
.backdrop-blur {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* Hero Section Animations */
.float-animation {
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

.pulse-animation {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* Custom Button Styles */
.btn-custom-gradient {
  background: linear-gradient(45deg, var(--bs-primary), var(--bs-purple));
  border: none;
  color: white;
  transition: all 0.3s ease;
}

.btn-custom-gradient:hover {
  background: linear-gradient(45deg, var(--bs-purple), var(--bs-primary));
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

/* Stats Counter Animation */
.stats-item {
  opacity: 0;
  transform: translateY(20px);
  animation: slideInUp 1s ease forwards;
}

.stats-item:nth-child(1) { animation-delay: 0.1s; }
.stats-item:nth-child(2) { animation-delay: 0.2s; }
.stats-item:nth-child(3) { animation-delay: 0.3s; }
.stats-item:nth-child(4) { animation-delay: 0.4s; }

@keyframes slideInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Phone Mockup Styles */
.phone-mockup {
  position: relative;
  max-width: 300px;
  margin: 0 auto;
}

.phone-mockup::before {
  content: '';
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: linear-gradient(45deg, var(--bs-primary), var(--bs-success), var(--bs-warning), var(--bs-danger));
  border-radius: 30px;
  z-index: -1;
  opacity: 0.1;
  animation: rotate 10s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Card Enhancements */
.card-enhanced {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Navbar Enhancements */
.navbar-brand-enhanced {
  transition: all 0.3s ease;
}

.navbar-brand-enhanced:hover {
  transform: scale(1.05);
}

/* Section Transitions */
.section-transition {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease;
}

.section-transition.visible {
  opacity: 1;
  transform: translateY(0);
}

/* Responsive Enhancements */
@media (max-width: 768px) {
  .hero-content {
    text-align: center;
  }
  
  .phone-mockup {
    max-width: 200px;
    margin-top: 2rem;
  }
  
  .stats-grid {
    gap: 1rem !important;
  }
  
  .header-carousel-item .display-4 {
    font-size: 2rem !important;
  }
  
  .header-carousel-item .fs-5 {
    font-size: 1rem !important;
  }
}

/* Loading Animation for Images */
.img-loading {
  background: linear-gradient(90deg, #f0f0f0 25%, transparent 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: var(--bs-primary);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--bs-primary-dark);
}

/* Attraction Image Grid Responsive */
@media (max-width: 992px) {
  #attractions .row > div {
    margin-bottom: 1rem;
  }
}

@media (max-width: 576px) {
  #attractions .col-6:nth-child(n+5) {
    display: none;
  }
  
  #attractions .col-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

/* Testimonial Card Hover Effects */
.testimonial-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
}

/* Progress Bar Animation */
@keyframes progressAnimation {
  0% { 
    width: 0%; 
    opacity: 1;
  }
  50% { 
    width: 100%; 
    opacity: 0.8;
  }
  100% { 
    width: 0%; 
    opacity: 1;
  }
}
/* Ensure table containers allow horizontal scroll */
table {
  display: block !important;
  overflow-x: auto !important;
  white-space: nowrap !important;
  overflow-y: visible !important;
}

/* Remove overflow:hidden from common wrappers */
.content-wrapper,
.card-body,
.card,
.section,
.admin-table-wrapper {
  overflow-x: visible !important;
  overflow-y: visible !important;
}`, "",{"version":3,"sources":["webpack://./src/CustomStyles.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD,4EAA4E;AAC5E;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,8DAA8D;AAC9D;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,oCAAoC;AACpC;;;;;;;;;EASE,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;;;;;;;;;EASE,gCAAgC;AAClC;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,yCAAyC;IACzC,0CAA0C;IAC1C,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,+DAA+D;AACjE;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,qEAAqE;AACvE;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,4BAA4B;AAC5B;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,yBAAyB;AACzB;EACE,uEAAuE;EACvE,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uEAAuE;EACvE,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;;AAElD;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6GAA6G;EAC7G,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE,6EAA6E;EAC7E,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,qCAAqC;AACrC;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA,mCAAmC;AACnC;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,SAAS;IACT,UAAU;EACZ;AACF;AACA,oDAAoD;AACpD;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,gDAAgD;AAChD;;;;;EAKE,8BAA8B;EAC9B,8BAA8B;AAChC","sourcesContent":["/* Custom Bootstrap Extensions for MastiShorts */\n\n/* IMPORTANT: Global Reset - Remove ALL underlines from the entire project */\n* {\n  text-decoration: none !important;\n}\n\n*:before, *:after {\n  text-decoration: none !important;\n}\n\n/* Global Reset - Remove underlines from all lists and links */\nul, ol, li {\n  text-decoration: none !important;\n  list-style: none;\n}\n\nul li, ol li {\n  text-decoration: none !important;\n}\n\na, a:hover, a:focus, a:active {\n  text-decoration: none !important;\n}\n\n.nav-link, .nav-link:hover, .nav-link:focus, .nav-link:active {\n  text-decoration: none !important;\n}\n\n/* Bootstrap nav override */\n.navbar-nav .nav-link {\n  text-decoration: none !important;\n}\n\n.navbar-nav .nav-link:hover {\n  text-decoration: none !important;\n}\n\n/* Comprehensive element overrides */\ndiv, span, p, h1, h2, h3, h4, h5, h6, \nul, ol, li, dl, dt, dd,\nnav, header, footer, main, section, article, aside,\nbutton, input, select, textarea, label,\n.card, .card-body, .card-title, .card-text,\n.btn, .nav, .navbar, .dropdown, .modal,\n.form-control, .form-label, .form-text,\n.list-group-item, .dropdown-item, .breadcrumb-item,\n.page-link, .nav-tabs .nav-link, .nav-pills .nav-link {\n  text-decoration: none !important;\n}\n\n/* Hover states */\ndiv:hover, span:hover, p:hover, h1:hover, h2:hover, h3:hover, h4:hover, h5:hover, h6:hover,\nul:hover, ol:hover, li:hover, dl:hover, dt:hover, dd:hover,\nnav:hover, header:hover, footer:hover, main:hover, section:hover, article:hover, aside:hover,\nbutton:hover, input:hover, select:hover, textarea:hover, label:hover,\n.card:hover, .card-body:hover, .card-title:hover, .card-text:hover,\n.btn:hover, .nav:hover, .navbar:hover, .dropdown:hover, .modal:hover,\n.form-control:hover, .form-label:hover, .form-text:hover,\n.list-group-item:hover, .dropdown-item:hover, .breadcrumb-item:hover,\n.page-link:hover, .nav-tabs .nav-link:hover, .nav-pills .nav-link:hover {\n  text-decoration: none !important;\n}\n\n/* Remove any extra margins and padding */\nsection {\n  margin: 0 !important;\n}\n\n/* Navbar Styles */\n.nav-bar {\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.nav-bar .navbar-brand h1 {\n  transition: all 0.3s ease;\n}\n\n.nav-bar .navbar-brand:hover h1 {\n  transform: scale(1.05);\n}\n\n.nav-bar .navbar-nav .nav-link {\n  position: relative;\n  transition: all 0.3s ease;\n  padding: 0.8rem 1rem !important;\n  margin: 0 0.2rem;\n  border-radius: 25px;\n}\n\n.nav-bar .navbar-nav .nav-link:hover {\n  background-color: rgba(13, 110, 253, 0.1);\n  color: var(--bs-primary) !important;\n}\n\n.nav-bar .navbar-nav .nav-link.active {\n  background-color: var(--bs-primary);\n  color: white !important;\n}\n\n/* Mobile Navbar Fixes */\n@media (max-width: 991.98px) {\n  .navbar-collapse {\n    background: rgba(255, 255, 255, 0.98);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border-radius: 10px;\n    margin-top: 10px;\n    padding: 15px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n  }\n  \n  .navbar-collapse.collapse:not(.show) {\n    display: none !important;\n  }\n  \n  .navbar-collapse.show {\n    display: block !important;\n  }\n  \n  .navbar-nav {\n    flex-direction: column;\n  }\n  \n  .nav-link {\n    text-align: center;\n    margin: 5px 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-collapse {\n    display: flex !important;\n    position: static;\n    background: none !important;\n    box-shadow: none !important;\n    border: none !important;\n    margin-top: 0 !important;\n    padding: 0 !important;\n  }\n  \n  .navbar-nav {\n    flex-direction: row;\n  }\n}\n\n/* Header Carousel Fixes */\n.header-carousel {\n  position: relative;\n  min-height: 100vh;\n  overflow: hidden;\n}\n\n.header-carousel-item {\n  position: absolute;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  transition: opacity 1s ease-in-out;\n}\n\n.header-carousel-item.active {\n  opacity: 1;\n}\n\n/* Hover Effects */\n.hover-lift {\n  transition: all 0.3s ease;\n}\n\n.hover-lift:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;\n}\n\n.hover-primary {\n  transition: all 0.3s ease;\n}\n\n.hover-primary:hover {\n  color: var(--bs-primary) !important;\n  transform: translateX(5px);\n}\n\n/* Gradient Backgrounds */\n.bg-gradient-primary {\n  background: linear-gradient(135deg, var(--bs-primary), #6f42c1);\n}\n\n.bg-gradient-success {\n  background: linear-gradient(135deg, var(--bs-success), #20c997);\n}\n\n.bg-gradient-info {\n  background: linear-gradient(135deg, var(--bs-info), #0dcaf0);\n}\n\n.bg-gradient-warning {\n  background: linear-gradient(135deg, var(--bs-warning), #fd7e14);\n}\n\n.bg-gradient-dark {\n  background: linear-gradient(135deg, rgba(0,0,0,0.8), rgba(0,0,0,0.4));\n}\n\n/* Backdrop Blur Effect */\n.backdrop-blur {\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n/* Hero Section Animations */\n.float-animation {\n  animation: float 6s ease-in-out infinite;\n}\n\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-20px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n.pulse-animation {\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Custom Button Styles */\n.btn-custom-gradient {\n  background: linear-gradient(45deg, var(--bs-primary), var(--bs-purple));\n  border: none;\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.btn-custom-gradient:hover {\n  background: linear-gradient(45deg, var(--bs-purple), var(--bs-primary));\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n}\n\n/* Stats Counter Animation */\n.stats-item {\n  opacity: 0;\n  transform: translateY(20px);\n  animation: slideInUp 1s ease forwards;\n}\n\n.stats-item:nth-child(1) { animation-delay: 0.1s; }\n.stats-item:nth-child(2) { animation-delay: 0.2s; }\n.stats-item:nth-child(3) { animation-delay: 0.3s; }\n.stats-item:nth-child(4) { animation-delay: 0.4s; }\n\n@keyframes slideInUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Phone Mockup Styles */\n.phone-mockup {\n  position: relative;\n  max-width: 300px;\n  margin: 0 auto;\n}\n\n.phone-mockup::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: -10px;\n  right: -10px;\n  bottom: -10px;\n  background: linear-gradient(45deg, var(--bs-primary), var(--bs-success), var(--bs-warning), var(--bs-danger));\n  border-radius: 30px;\n  z-index: -1;\n  opacity: 0.1;\n  animation: rotate 10s linear infinite;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Card Enhancements */\n.card-enhanced {\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Navbar Enhancements */\n.navbar-brand-enhanced {\n  transition: all 0.3s ease;\n}\n\n.navbar-brand-enhanced:hover {\n  transform: scale(1.05);\n}\n\n/* Section Transitions */\n.section-transition {\n  opacity: 0;\n  transform: translateY(30px);\n  transition: all 0.6s ease;\n}\n\n.section-transition.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Responsive Enhancements */\n@media (max-width: 768px) {\n  .hero-content {\n    text-align: center;\n  }\n  \n  .phone-mockup {\n    max-width: 200px;\n    margin-top: 2rem;\n  }\n  \n  .stats-grid {\n    gap: 1rem !important;\n  }\n  \n  .header-carousel-item .display-4 {\n    font-size: 2rem !important;\n  }\n  \n  .header-carousel-item .fs-5 {\n    font-size: 1rem !important;\n  }\n}\n\n/* Loading Animation for Images */\n.img-loading {\n  background: linear-gradient(90deg, #f0f0f0 25%, transparent 37%, #f0f0f0 63%);\n  background-size: 400% 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n/* Custom Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--bs-primary);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--bs-primary-dark);\n}\n\n/* Attraction Image Grid Responsive */\n@media (max-width: 992px) {\n  #attractions .row > div {\n    margin-bottom: 1rem;\n  }\n}\n\n@media (max-width: 576px) {\n  #attractions .col-6:nth-child(n+5) {\n    display: none;\n  }\n  \n  #attractions .col-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n\n/* Testimonial Card Hover Effects */\n.testimonial-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);\n}\n\n/* Progress Bar Animation */\n@keyframes progressAnimation {\n  0% { \n    width: 0%; \n    opacity: 1;\n  }\n  50% { \n    width: 100%; \n    opacity: 0.8;\n  }\n  100% { \n    width: 0%; \n    opacity: 1;\n  }\n}\n/* Ensure table containers allow horizontal scroll */\ntable {\n  display: block !important;\n  overflow-x: auto !important;\n  white-space: nowrap !important;\n  overflow-y: visible !important;\n}\n\n/* Remove overflow:hidden from common wrappers */\n.content-wrapper,\n.card-body,\n.card,\n.section,\n.admin-table-wrapper {\n  overflow-x: visible !important;\n  overflow-y: visible !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
